import React from 'react';
import Header from '../../components/header';
import ContactBody from './body';
import Footer from '../../components/footer';

function Contact(props) {
    document.title = `Yebokenny | Contact Us`;
    return (
        <div>
            <Header></Header>
            <ContactBody></ContactBody>
            <Footer></Footer>
        </div>
    );
}

export default Contact;